import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const ARRapportMeny: IRapportInfo[] = [];

export default ARRapportMeny;
